import React from 'react';
import {
  Paper,
  Box,
  TextField,
  InputAdornment,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import { Search, FilterList } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

interface ProductFiltersProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
  filterCategory: string;
  onCategoryChange: (value: string) => void;
}

const ProductFilters: React.FC<ProductFiltersProps> = ({
  searchQuery,
  onSearchChange,
  filterCategory,
  onCategoryChange,
}) => {
  const { t } = useTranslation();

  return (
    <Paper
      sx={{
        p: 3,
        mb: 3,
        bgcolor: 'background.paper',
        borderRadius: '8px',
        border: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Box sx={{
        display: 'flex',
        gap: 2,
        flexWrap: 'wrap',
        flexDirection: { xs: 'column', sm: 'row' }
      }}>
        <TextField
          placeholder={t('admin.searchProducts')}
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          size="small"
          sx={{
            flex: { xs: 'none', sm: 1 },
            minWidth: { xs: '100%', sm: 300 }
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search sx={{ color: 'text.secondary' }} />
              </InputAdornment>
            ),
          }}
        />
        <FormControl sx={{ minWidth: { xs: '100%', sm: 200 } }} size="small">
          <InputLabel>{t('products.category')}</InputLabel>
          <Select
            value={filterCategory}
            label={t('products.category')}
            onChange={(e) => onCategoryChange(e.target.value as string)}
            startAdornment={<FilterList sx={{ mr: 2, color: 'text.secondary' }} />}
          >
            <MenuItem value="">{t('products.allCategories')}</MenuItem>
            <MenuItem value="imaging">{t('productCategories.imagingEquipment')}</MenuItem>
            <MenuItem value="surgical">{t('productCategories.surgicalEquipment')}</MenuItem>
            <MenuItem value="diagnostic">{t('productCategories.diagnosticEquipment')}</MenuItem>
            <MenuItem value="monitoring">{t('productCategories.monitoringEquipment')}</MenuItem>
            <MenuItem value="laboratory">{t('productCategories.laboratoryEquipment')}</MenuItem>
          </Select>
        </FormControl>
      </Box>
    </Paper>
  );
};

export default ProductFilters;